const api = (endpoint: string) =>
  `${process.env.NEXT_PUBLIC_API_GATEWAY}/${endpoint}`;

const oldApi = (endpoint: string) =>
  `${process.env.NEXT_PUBLIC_OLD_API_GATEWAY}/${endpoint}`;
const newApi = (endpoint: string) =>
  `${process.env.NEXT_PUBLIC_NEW_API_GATEWAY}/${endpoint}`;
const wizzyApi = (endpoint: string) =>
  `${process.env.NEXT_PUBLIC_WIZZY_API}/${endpoint}`;
const unbxdApi = (endpoint: string) =>
  `${process.env.NEXT_PUBLIC_UNBXD_API}/${endpoint}`;
const unbxdSearchApi = (endpoint: string) =>
  `${process.env.NEXT_PUBLIC_UNBXD_SEARCH_API}/${endpoint}`;

const shapeOfYouApi = (endpoint: string) =>
  `${process.env.NEXT_PUBLIC_SHAPE_OF_YOU_API}/${endpoint}`;

const similarApi = (endpoint: string) =>
  `${process.env.NEXT_PUBLIC_SIMILAR_API}/${endpoint}`;

const endpoints = {
  products: {
    categorySlugbyName: (name: any) => newApi(`category/by-name?name=${name}`),
    storeLocation: () => newApi("product/store-availability"),
    similarproduct: () => similarApi(`similarity`),
    category: (id: number) => newApi(`product/category/${id}`),
    filters: (id: number) => newApi(`product/category/filters/${id}`),
    product: (slug: string) => newApi(`product/${slug}`),
    related: (slug: string) => newApi(`product/${slug}/related`),
    search: () => newApi(`product/search`),
    searchFilters: () => newApi(`product/search/filters`),
    searchWizzy: () => wizzyApi(`products/search`),
    searchWizzyFilters: () => wizzyApi(`products/filter`),
    searchMoreWizzy: () => wizzyApi(`products/filter`),
    searchUnbxd: () =>
      unbxdSearchApi(
        `${process.env.NEXT_PUBLIC_UNBXD_API_KEY}/${process.env.NEXT_PUBLIC_UNBXD_SITE_NAME}/search`
      ),
    categoryUnbxd: () =>
      unbxdSearchApi(
        `${process.env.NEXT_PUBLIC_UNBXD_API_KEY}/${process.env.NEXT_PUBLIC_UNBXD_SITE_NAME}/category`
      ),

    searchUnbxdFilters: () =>
      unbxdSearchApi(
        `${process.env.NEXT_PUBLIC_UNBXD_API_KEY}/products/filter`
      ),
    searchMoreUnbxd: () =>
      unbxdSearchApi(
        `${process.env.NEXT_PUBLIC_UNBXD_API_KEY}/products/filter`
      ),
    autoCompleteWizzy: () => wizzyApi(`autocomplete`),

    autoComplete: () =>
      unbxdSearchApi(
        `${process.env.NEXT_PUBLIC_UNBXD_API_KEY}/${process.env.NEXT_PUBLIC_UNBXD_SITE_NAME}/autosuggest`
      ),
  },
  category: {
    detail: (category: string) => newApi(`category/${category}`),
    mapping: (id: number) => newApi(`category/mapping/${id}`),
    tree: (id: number | string) => newApi(`category/tree/${id}`),
  },
  page: (slug: string) => newApi(`cms/page/${slug}`),
  sencoOffer: () => oldApi(`api/offer`),
  checkPincode: (pincode: any) => newApi(`order/check-pincode/${pincode}`),
  mgOffer: () => oldApi(`api/offer/mg`),
  franchiseEnquiry: () => newApi(`cms/franchise-enquiry`),
  franchiseOtp: {
    sendMobileOtp: () => newApi("cms/franchise-enquiry/mobile-otp/send"),
    verifyMobileOtp: () => newApi("cms/franchise-enquiry/mobile-otp/verify"),
    sendEmailOtp: () => newApi("cms/franchise-enquiry/email-otp/send"),
    verifyEmailOtp: () => newApi("cms/franchise-enquiry/email-otp/verify"),
  },
  pbAndAtOffer: () => oldApi(`api/offer/pb-and-at`),
  countries: () => newApi("cms/countries"),
  state: (country: any) => newApi(`cms/states/${country}`),
  statefromPin: (pin: any) =>
    `https://maps.googleapis.com/maps/api/geocode/json?address=${pin}&key=${process.env.NEXT_PUBLIC_GOOGLE_KEY}`,
  wedding: () => newApi(`cms/di-wedding`),
  weddingOtp: {
    send: () => newApi(`cms/di-wedding/send-otp`),
    verify: () => newApi(`cms/di-wedding/verify-otp`),
  },
  unbxd: () =>
    unbxdApi(
      `${process.env.NEXT_PUBLIC_UNBXD_API_KEY}/${process.env.NEXT_PUBLIC_UNBXD_SITE_NAME}/items`
    ),
  auth: {
    sendOtp: () => newApi("auth/send-signup-otp"),
    signup: () => newApi("auth/signup"),
    loginSendOtp: () => newApi("auth/send-login-otp"),
    loginVerifyOtp: () => newApi("auth/verify-login-otp"),
    user: () => newApi("auth/profile"),
    address: () => newApi("auth/address"),
    addAddress: () => newApi("auth/add-address"),
    deleteAddress: (uid: any) => newApi(`auth/delete-address/${uid}`),
    updateAddress: (uid: any) => newApi(`auth/update-address/${uid}`),
    orders: () => newApi("order/list"),
    orderDetail: (oid: any) => newApi(`order/${oid}`),
    orderStatus: () => newApi("order/status-sequence"),
    orderTimeline: (oid: any, id: any) => newApi(`order/${oid}/track/${id}`),
    profileUpdate: () => newApi("auth/update-profile"),
    billingAddressUpdate: () => newApi("auth/update-billing-address"),
    getConsentForm: () => newApi("auth/get-consent-form"),
    updateConsentForm: () => newApi("auth/update-consent-form"),
    update_pancard: () => newApi(`auth/update-pancard`),
    subscribe: () => newApi(`auth/subscribe`),
  },
  cart: {
    add: () => newApi("cart/add"),
    remove: (id: any) => newApi("cart/remove/" + id),
    refresh: () => newApi("cart/refresh"),
    items: () => newApi("cart/items"),
    applyCoupon: () => newApi("discount/easyrewardz/apply"),
    availableCoupon: () => newApi("discount/easyrewardz/list"),
    removeCoupon: () => newApi("discount/easyrewardz/remove"),
    couponVerifyOtp: () => newApi("discount/easyrewardz/verify-otp"),
    couponResendOtp: () => newApi("discount/easyrewardz/resend-otp"),
    dGSendOtp: () => newApi("discount/digi/apply"),
    dGVerifyOtp: () => newApi("discount/digi/verify-otp"),
    dGRemove: () => newApi("discount/digi/remove"),
  },
  home: {
    banner: () => newApi("cms/banners"),
    menu: () => newApi("cms/menus"),
    footerMenu: () => newApi("cms/menus/footer"),
    popularSearches: () => newApi("cms/popular-searches"),
    ticker: () => newApi("cms/ticker"),
    customerFavourites: () => newApi("product/flag/best_seller"),
    newArrival: () => newApi("product/flag/new_arrival"),
    dealOfTheDay: () => newApi("product/flag/deal_of_the_day"),
    trendingDesign: () => newApi(`product/list-by-slugs`),
    mensCollections: () => newApi(`category/mens-collections`),
    subscribe: () => api(`page/subscribe`),
    live: () => newApi(`cms/firework-live`),
    liveMobile: () => oldApi(`api/widget/live-mobile`),
  },
  blog: {
    list: () => newApi("blog"),
    byCategory: (slug: string) => newApi("blog/category/" + slug),
    detail: (slug: string) => newApi("blog/" + slug),
  },
  solitaire: {
    filters: () => oldApi("api/solitaire/filters"),
    list: () => oldApi("api/solitaire"),
    detail: (slug: string) => oldApi("api/solitaire/" + slug),
  },
  status: (txnid: any) => newApi(`order/status/${txnid}`),
  storesData: () => newApi("cms/stores"),
  wishlist: {
    items: () => newApi(`wishlist/items`),
    add: () => newApi(`wishlist/add`),
    remove: () => newApi(`wishlist/remove`),
  },
  order: {
    checkout: () => newApi("order/checkout"),
    checkoutv2: () => newApi("order/checkout/v2"),
    orders: () => newApi("order/list"),
  },
  gamize: {
    load: () => `${process.env.NEXT_PUBLIC_GAMIZE_API}/gamaiz_api.php`,
  },
  giftCard: {
    purpose: () => newApi("giftcard/purposes"),
    template: () => newApi("giftcard/giftcard-templates"),
    purchase: () => newApi("giftcard/create"),
    purchasev2: () => newApi("giftcard/create/v2"),
    paymentStatus: (oid: any) => newApi(`giftcard/status/${oid}`),
    orderHistory: () => newApi(`giftcard/list`),
    checkBalance: () => newApi(`giftcard/check-balance/send-otp`),
    checkbalanceOtp: () => newApi(`giftcard/check-balance/verify-otp`),
    redeemtion: () => newApi(`discount/gift-card/apply`),
    redeemtionOtp: () => newApi(`discount/gift-card/verify-otp`),
    removeGiftcard: () => newApi(`discount/gift-card/remove`),
  },
  astro: {
    zodiacList: () => newApi("astro/zodiac"),
    astrologerList: () => newApi("astro/astrologer"),
    astrologerDetails: (slug: any) => newApi(`astro/astrologer/${slug}`),
    astroAppointmentList: () => newApi("astro/appointment/list"),
    kundaliList: () => newApi("astro/kundali/list"),

    bookAppointmentv2: () => newApi("astro/appointment/v2"),
    bookAppointment: () => newApi("astro/appointment"),
    horoscope: (name: any, date: any) =>
      newApi(`astro/horoscope/${name}/${date}`),
    kundaliTypes: () => newApi("astro/kundali/types"),
    bookKundali: () => newApi("astro/kundali"),
    bookKundaliv2: () => newApi("astro/kundali/v2"),
    appointmentStatus: (oid: any) => newApi(`astro/appointment/status/${oid}`),
    kundaliStatus: (oid: any) => newApi(`astro/kundali/status/${oid}`),
    coupon: (oid: any) => newApi(`astro/appointment/${oid}/coupon-apply`),
    otp: (oid: any) => newApi(`astro/appointment/${oid}/coupon-verify-otp`),
    resend: (oid: any) => newApi(`astro/appointment/${oid}/coupon-resend-otp`),

    cancelCoupon: (oid: any) =>
      newApi(`astro/appointment/${oid}/coupon-remove`),
  },
  search: {},
  stores: {
    states: () => newApi(`cms/stores/states`),
    cities: (state: string) => newApi(`cms/stores/${state}/cities`),
    stores: (state: string, city: string) =>
      newApi(`cms/stores/${state}/${city}`),
    store: (slug: string) => newApi(`cms/stores/${slug}`),
  },
  store_appointment: {
    create: () => newApi(`store-appointment/create`),
    list: () => newApi(`store-appointment/list`),
  },
  oldGoldExchangeAppointment: {
    create: () => newApi(`old-gold-exchange-appointment/create`),
    list: () => newApi(`old-gold-exchange-appointment/list`),
  },
  gold: {
    create: () => newApi(`goldbooking/create`),
    status: (id: string) => newApi(`goldbooking/status/${id}`),
    list: () => newApi(`goldbooking/list`),
  },
  silver: {
    create: () => newApi(`silverbooking/create`),
    status: (id: string) => newApi(`silverbooking/status/${id}`),
    list: () => newApi(`silverbooking/list`),
  },
  feedback: {
    option: () => newApi("feedback/option-choices"),
    feedback: () => newApi("feedback/purchase"),
    feedbackOrder: () => newApi("feedback/order"),
    feedbackSummary: (slug: any) => newApi(`product/${slug}/reviews/summary`),
    feedbackSummaryList: (slug: any) => newApi(`product/${slug}/reviews`),
    reviewByCustomer: (slug: any, id: any) =>
      newApi(`product/${slug}/reviews/${id}`),
  },
  analytics: {
    track: () => newApi("analytics/track/referrer"),
  },
  calculator: {
    list: () => newApi("calculator/list"),
  },
  shape_of_you: {
    profile: () => shapeOfYouApi("api/shape-of-you/recommendations/profile"),
    faceAnalysis: () => shapeOfYouApi("api/shape-of-you/face-analysis"),
    run: () => shapeOfYouApi("api/shape-of-you/recommendations/run"),
    products: () =>
      shapeOfYouApi("api/shape-of-you/recommendations/products-v2"),
    list: () => shapeOfYouApi("api/shape-of-you/recommendations/options"),
    image: () =>
      shapeOfYouApi("api/image-augmentation/face_necklace_earring_v3"),
    log: () => newApi("cms/shape-of-you/log"),
  },
  corporate_sales:{
    enquiry: () => newApi("cms/corporate-sales-enquiry"),
    sendMobileOtp: () => newApi("cms/corporate-sales-enquiry/mobile-otp/send"),
    verifyMobileOtp: () => newApi("cms/corporate-sales-enquiry/mobile-otp/verify"),
  },
};

export default endpoints;
